import __request__ from "routing/request";
export function administration(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.sidecar/sidecar/administration", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function setAction(JSONbody, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.sidecar/sidecar/administration/action", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
